var UtilTweenAnimation = /** @class */ (function () {
    function UtilTweenAnimation() {
        var _this = this;
        this.getBezierCurvePoints = function (center, count, endRadius, bezierRadius, bezierAngle) {
            var splitAngle = 360 / count;
            var angle = 0;
            var endPoints = [];
            var bezierPoints = [];
            while (count > 0) {
                endPoints.push(_this.getCoordinatesOnCircumference(center, endRadius, angle));
                bezierPoints.push(_this.getCoordinatesOnCircumference(center, bezierRadius, angle - bezierAngle));
                angle = angle + splitAngle;
                count = count - 1;
            }
            return {
                bezierPoints: bezierPoints,
                endPoints: endPoints,
            };
        };
        this.getCoordinatesOnCircumference = function (origin, radius, angle) {
            var angleInRadian = (angle * Math.PI) / 180;
            var x = origin.x + radius * Math.cos(angleInRadian);
            var y = origin.y + radius * Math.sin(angleInRadian);
            return { x: x, y: y };
        };
    }
    return UtilTweenAnimation;
}());
export var utilTweenAnimation = new UtilTweenAnimation();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilTweenAnimation.ts
// module id = 2321
// module chunks = 3